// Form.run enhancer for job posting requests
document.addEventListener('DOMContentLoaded', function() {
  // Check if we're on the contact page with Form.run
  const formrunEmbed = document.querySelector('.formrun-embed');
  if (!formrunEmbed) return;
  
  // Wait for Form.run to initialize
  const checkFormRunLoaded = setInterval(function() {
    const formrunForm = document.querySelector('.formrun');
    if (formrunForm) {
      clearInterval(checkFormRunLoaded);
      enhanceFormRun(formrunForm);
    }
  }, 500);
  
  function enhanceFormRun(form) {
    // Find the inquiry type dropdown if it exists
    const inquiryTypeField = Array.from(form.querySelectorAll('.formrun-item')).find(
      item => item.textContent.includes('お問い合わせ種別') || 
              item.textContent.includes('お問い合わせの種類')
    );
    
    if (!inquiryTypeField) {
      console.warn('Could not find inquiry type field in Form.run');
      return;
    }
    
    // Find the select element
    const selectElement = inquiryTypeField.querySelector('select');
    if (!selectElement) {
      console.warn('Could not find select element in inquiry type field');
      return;
    }
    
    // Check if "求人掲載希望" option already exists
    const optionExists = Array.from(selectElement.options).some(
      option => option.text === '求人掲載希望'
    );
    
    // Add the option if it doesn't exist
    if (!optionExists) {
      const newOption = document.createElement('option');
      newOption.text = '求人掲載希望';
      newOption.value = '求人掲載希望';
      selectElement.add(newOption);
    }
    
    // Create company-specific fields container
    const companyFieldsContainer = document.createElement('div');
    companyFieldsContainer.className = 'company-fields-container';
    companyFieldsContainer.style.display = 'none';
    
    // Create company-specific fields
    const companyFields = [
      {
        label: '会社名',
        name: 'company_name',
        type: 'text',
        required: true
      },
      {
        label: '担当者名',
        name: 'contact_person',
        type: 'text',
        required: true
      },
      {
        label: '会社URL',
        name: 'company_url',
        type: 'url',
        required: false
      },
      {
        label: '希望する掲載内容',
        name: 'posting_content',
        type: 'textarea',
        required: false
      }
    ];
    
    // Add fields to container
    companyFields.forEach(field => {
      const fieldContainer = document.createElement('div');
      fieldContainer.className = 'formrun-item';
      
      const labelElement = document.createElement('label');
      labelElement.className = 'formrun-item-title';
      labelElement.textContent = field.label;
      if (field.required) {
        const requiredSpan = document.createElement('span');
        requiredSpan.className = 'formrun-require';
        requiredSpan.textContent = '必須';
        labelElement.appendChild(requiredSpan);
      }
      
      let inputElement;
      if (field.type === 'textarea') {
        inputElement = document.createElement('textarea');
        inputElement.rows = 4;
      } else {
        inputElement = document.createElement('input');
        inputElement.type = field.type;
      }
      
      inputElement.name = field.name;
      inputElement.className = 'formrun-input';
      if (field.required) {
        inputElement.setAttribute('data-formrun-required', 'true');
      }
      
      fieldContainer.appendChild(labelElement);
      fieldContainer.appendChild(inputElement);
      companyFieldsContainer.appendChild(fieldContainer);
    });
    
    // Insert company fields after the inquiry type field
    inquiryTypeField.parentNode.insertBefore(companyFieldsContainer, inquiryTypeField.nextSibling);
    
    // Show/hide company fields based on selection
    selectElement.addEventListener('change', function() {
      if (this.value === '求人掲載希望') {
        companyFieldsContainer.style.display = 'block';
      } else {
        companyFieldsContainer.style.display = 'none';
      }
    });
  }
});
